import { FilterOption } from '../../../../../ui-components/lib/filter-dropdown/filter-dropdown.model';
import { FilterMapping } from '../../../../../ui-components/lib/filter-dropdown/filter-mapping.enum';
import { TableFilterTab } from '../../../../../ui-components/lib/table/table.model';
import { RequestTypeEnum } from '../../../../common/enums/request-type';
import { Insight } from '../../../../common/models/insight.model';
import { ActionList } from '../../../../common/models/action-list.model';
import { EMPLOYEE_ROUTES } from '../../../../common/constants/employee.routing.constants';
import { ENDPOINTS } from '../../../../common/constants/endpoints.constants';
import { RELATED_REQUESTS_COLUMN_HEADER } from '../../const';

export const CLOSED_TASK_INSIGHTS: Insight[] = [
  {
    label:
      'my_organization_details_screen_closed_requests_tab_first_insight_label',
    value: '0',
    iconName: 'edit_square',
  },
  {
    label:
      'my_organization_details_screen_closed_requests_tab_second_insight_label',
    value: '0',
    iconName: 'timer_start',
  },
  {
    label:
      'my_organization_details_screen_closed_requests_tab_third_insight_label',
    value: '0',
    iconName: 'task_view',
  },
];

export const CLOSED_TASK_VIEW_DETAILS_ACTION: ActionList = {
  key: 'view_details',
  hasIcon: true,
  label: 'view_details_action_item',
  hasDivider: false,
  labelCustomStyle: '',
  hasToggle: false,
  toggleValue: false,
  isLink: true,
};

export const CLOSED_TASK_DEFAULT_COLUMNS = [
  {
    header: '',
  },
  {
    header: 'closed_request_screen_table_header_id_title',
    showViewIcon: true,
    viewIconRouterLink: (row: any) => [
      `${EMPLOYEE_ROUTES.MY_ORGANIZATION.REQUEST}/${RequestTypeEnum.ACTION}/${row.id.toString()}`,
    ],
    isSortable: true,
    sortKey: 'request_id][type',
  },
  {
    header: 'closed_request_screen_table_header_request_name_title',
    isSortable: true,
    sortKey: 'workflow_type][type',
  },
  {
    header: 'closed_request_screen_table_header_creation_date_title',
    isSortable: true,
    sortKey: 'creation_date][type',
  },
  {
    header: 'closed_request_screen_table_header_creator_title',
    isSortable: true,
    sortKey: 'creator][type',
  },
  {
    header: 'closed_request_screen_table_header_completion_date_title',
    isSortable: true,
    sortKey: 'completion_date][type',
  },
  {
    header: 'closed_request_screen_table_header_request_subject_title',
    isSortable: true,
    sortKey: 'request_subject][type',
  },
  {
    header: 'closed_request_screen_table_header_related_project_title',
    isSortable: true,
    sortKey: 'related_project][type',
  },
  {
    header: 'closed_request_screen_table_header_status_title',
    isSortable: true,
    sortKey: 'state][type',
  },
  {
    header: RELATED_REQUESTS_COLUMN_HEADER,
    isSortable: false,
  },
  {
    header: '',
  },
];

export const CLOSED_TASK_TABLE_FILTER_TABS: TableFilterTab[] = [
  {
    key: 'current',
    identifier: 'current',
    label: 'closed_request_screen_table_filter_current_month_label',
    active: true,
    iconName: 'calendar',
  },
  {
    key: 'previous',
    identifier: 'previous',
    label: 'closed_request_screen_table_filter_previous_month_label',
    active: false,
    iconName: 'calendar',
  },
  {
    key: 'all',
    identifier: 'all',
    label: 'closed_request_screen_table_filter_all_time_label',
    active: false,
    iconName: 'calendar',
  },
];

export const CLOSED_TASK_FILTER_OPTIONS: FilterOption[] = [
  {
    key: 'workflowTypes',
    label: 'closed_request_screen_filter_workflow_types_label',
    type: 'multi',
    apiUrl: ENDPOINTS.filters.workflowType,
    placeholder: 'closed_request_screen_filter_workflow_types_placeholder',
  },
  {
    key: 'creationDate',
    label: 'closed_request_screen_filter_creation_date_label',
    type: 'dateRange',
  },
  {
    key: 'status',
    label: 'closed_request_screen_filter_status_label',
    type: 'multi',
    apiUrl: ENDPOINTS.filters.status,
  },
  {
    key: 'projectIds',
    label: 'vendor_invoice_page_table_filter_option_product',
    type: 'multi',
    apiUrl: ENDPOINTS.Lookup.project,
    placeholder: 'vendor_invoice_page_table_filter_option_product_placeholder',
  },
];

export const CLOSED_TASK_INSIGHT_KEYS = {
  approvedRequests: 'approved_requests',
  rejectedRequests: 'rejected_requests',
  averageCompletionOnTime: 'average_completion_on_time',
} as const;

export const CLOSED_TASK_FILTER_MAPPING: Record<string, string> = {
  workflowTypes: FilterMapping.WORKFLOW_TYPES_FLOWS,
  creationDateStart: FilterMapping.CREATED_AFTER_REQUESTS,
  creationDateEnd: FilterMapping.CREATED_BEFORE_REQUESTS,
  status: FilterMapping.PROJECT_STATES,
  projectIds: FilterMapping.PROJECT_IDS,
};
